var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 336V496H16V336H496Z",
    fill: "#E74C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 176V336H16V176H496Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 16V176H16V16H496Z",
    fill: "#27AE60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3979 142.732V160.662M25.6943 144.725H53.0366H25.6943ZM26.746 162.654V152.693H35.159V160.662H43.5719V152.693H38.3138L26.746 162.654ZM29.9008 160.662H32.0041H29.9008ZM53.0366 160.662H47.7784V152.693H56.1914L53.0366 160.662ZM56.1914 142.732V160.662H64.6044V142.732H56.1914Z",
    stroke: "white",
    strokeWidth: 2.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7268 170.622H65.656M25.6943 170.622H44.6236H25.6943Z",
    stroke: "white",
    strokeWidth: 5.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M225.03 302.343C236.353 306.022 248.6 305.666 259.691 301.337C270.781 297.008 280.031 288.972 285.867 278.595C291.703 268.218 293.766 256.141 291.706 244.415C289.645 232.689 283.587 222.039 274.562 214.273C280.435 222.963 283.773 233.115 284.202 243.594C284.632 254.073 282.136 264.465 276.995 273.606C271.854 282.747 264.27 290.276 255.092 295.352C245.915 300.427 235.505 302.848 225.03 302.343",
    fill: "#E74C3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M290.936 292.457C298.377 288.156 304.366 281.731 308.133 274.005C311.9 266.279 313.275 257.605 312.081 249.093C310.887 240.581 307.179 232.619 301.432 226.228C295.685 219.837 288.16 215.307 279.823 213.219C285.764 217.685 290.765 223.28 294.54 229.683C298.315 236.086 300.79 243.171 301.822 250.532C302.855 257.892 302.424 265.385 300.556 272.579C298.688 279.773 295.419 286.528 290.936 292.457",
    fill: "#E74C3C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M256 311.588L253.175 255.088L256 210.607C257.716 213.005 260.01 214.931 262.669 216.206V249.415L260.396 305.537L256 311.588Z",
    fill: "#E74C3C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M254.87 207.064L256 208.125C257.149 209.759 258.859 210.914 260.804 211.371C262.749 211.828 264.794 211.555 266.551 210.604C268.308 209.652 269.654 208.089 270.335 206.21C271.015 204.332 270.982 202.269 270.242 200.413C269.95 201.959 269.193 203.378 268.071 204.48C266.949 205.583 265.517 206.316 263.967 206.58C262.417 206.845 260.822 206.63 259.398 205.962C257.974 205.295 256.788 204.208 256 202.847",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIr);
export default __webpack_public_path__ + "static/media/IR.544ff0c2b3e59a2deef86f68dff130b7.svg";
export { ForwardRef as ReactComponent };